import { bl_fi_generic_doc_line_xtn_doc_line_matching_balance_RowClass, bl_fi_generic_doc_line_xtn_doc_line_matching_balance_RowInterface } from "../../dbschema/bl_fi_generic_doc_line_xtn_doc_line_matching_balance.model";
import { BaseContainerModel } from "../base-container.model";

export class GenDocLineXtnDocLineMatchingBalanceContainerModel extends BaseContainerModel{
  bl_fi_generic_doc_line_xtn_doc_line_matching_balance: bl_fi_generic_doc_line_xtn_doc_line_matching_balance_RowInterface = new bl_fi_generic_doc_line_xtn_doc_line_matching_balance_RowClass();
}
